import React, { useEffect, useState ,useRef} from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.min.js';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { useAuth } from '../../AuthContext';
import Select from 'react-select';
import axiosInstance from "../../axiosInstance";
import './modal.css'



const ModalExample = ({ closeAddModal, data, open, mode,setIsopen,setMessage,setType,setIsAdded }) => {

   const { teachers,user }  = useAuth()

 //  const [centersList,setCenterList] = useState([]);
   const removedCenterRef = useRef([]);
   const [input,setInput] = useState('');
   const [showList,setShowList] = useState(true);



  const [formData, setFormData] = useState({
    id: '',
    username: '',
    email: '',
    qualification: '',
    pin: '',
    birthDate: '',
    mobileNo: '',
    level: '',
    centers: [], 
    removedCenters:[],
    teacherCode:'',
    password:'',
    studentCount:""
  });

  useState(()=>{
    setFormData({
      id: '',
      username: '',
      email: '',
      qualification: '',
      pin: '',
      birthDate: '',
      mobileNo: '',
      level: '',
      centers: [], 
      removedCenters:[],
      teacherCode:'',
      password:''
    })

  },[])



  useEffect(() => {
    if (mode === 'View') {
      setFormData(data);  
      //setShowList(false)
    }
  }, [data, mode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
   
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,  
    }));
  };

  const handleTrainer = (selectedValue) =>{
    setFormData((prevData) => ({
      ...prevData,  
      ['trainerTeacherId']: selectedValue.id,  
    }));
  }

  const handleSubmit = (e) => {

    e.preventDefault();

    if (mode === 'add') {

      axiosInstance.post('/addNewTeacher',formData).then((res)=>{
        setType("success")
        setMessage("Teacher Added Successfully")
        setIsAdded(true);
        closeAddModal()


      }).catch((e)=>{
        // setMessage(e.getMessage());
        console.log(e.response.data,"error")
        setType("error")
        setMessage(e.response.data);
        closeAddModal()
        

      })
    }else{
      axiosInstance.post('/editTeacher',formData).then((res)=>{
         setType("success")
        setMessage("Teacher Edited Successfully!!")
        closeAddModal()

      }).catch((e)=>{
         setType("error")
          setMessage(e.response.data);
           closeAddModal()

        console.log(e,"error")

      })
    }
   
  };


  const handleAddOption =(e)=>{
    e.preventDefault()
    let li = formData.centers;
    if(input!=='' ){
      li.push(input);

      setFormData((prevData) => ({
        ...prevData,  
        ['centers']:li,  
      }));

     

    }
   
    setInput('');

  }


  const removeCenterFromFrontend=(center)=>{
    removedCenterRef.current = [...removedCenterRef.current,center]

    setFormData((prevData)=>({
      ...prevData,
      ['centers']:formData.centers.filter(cr=>cr!==center),
     ['removedCenters']:removedCenterRef.current
    }))

  }




  return (
    <Modal open={open} onClose={()=>{
      setMessage("")
      setType("info")
      closeAddModal()

      }}>
      <div className="container">
        <form name="teacherForm"  onSubmit={handleSubmit}>
          <div className="row">
           
            <div className="input-field">
              <input
              className='custom'
                name="name"
                type="text"
                value={formData.name || ''}
                onChange={handleChange}
            
              />
              <label className="active">Full Name</label>
            </div>

            <div className="input-field">
              <input
              className='custom'
                name="teacherCode"
                type="number"
                value={formData.teacherCode || ''}
                onChange={handleChange}
            
              />
              <label className="active">Teacher Code</label>
            </div>
           
          </div>

         <div className='row'>
            
         <div className="input-field">
              <input
               className='custom'
                name="email"
                type="email"
                value={formData.email || ''}
                onChange={handleChange}
              />
              <label className="active">Email</label>
            </div>
            <div className="input-field">
            <input
              className='custom'
                name="qualification"
                type="text"
                value={formData.qualification || ''}
                onChange={handleChange}
              />
              <label className="active">Qualification</label>
            </div>
            <div className="input-field">
              <input
                className='custom'
                name="level"
                type="number"
                value={formData.level || ''}
                onChange={handleChange}
              />
              <label className="active">Level</label>
            </div>
           

         </div>

        

          <div className="row">
         
            <div className="input-field">
              <input
                className='custom'
                name="mobileNo"
                type="text"
                value={formData.mobileNo || ''}
                onChange={handleChange}
              />
              <label className="active">Mobile No</label>
            </div>
            <div className="input-field">
              <input
                className='custom'
                name="pin"
                type="text"
                value={formData.pin || ''}
                onChange={handleChange}
              />
              <label className="active">Pin</label>
            </div>
          </div>

          
          <div className="row">
            <div className="input-field">
              <input
                 className='custom'
                name="birthDate"
                type="date"
                value={formData.birthDate || ''}
                onChange={handleChange}
              />
              <label className="active">Birth Date</label>
            </div>
            {(mode !== 'View') && <div className="input-field">
              <input
                 className='custom'
                name="password"
                type="text"
                value={formData.password || ''}
                onChange={handleChange}
              />
              <label className="active">Password</label>
            </div>}

            <div className='row'>
                <div className="input-field">
              <input
                 className='custom'
                name="birthDate"
                // type="date"
                value={formData.studentCount || 0}
                // onChange={handleChange}
              />
              <label className="active">total Students</label>
            </div>

            </div>
           
          </div>

          <div className="row-col">
           
            <div className="input-field">
               <div style={{display:'flex'}}>
                <input
                  value={input}
                  onChange={(e) => {
                    e.preventDefault()
                    setInput(e.target.value)
                  }}
                  placeholder="Add new option"
                />
                <button className='addNewButton' onClick={handleAddOption}>+</button>
                </div>
              </div>
            <button className='centerList' onClick={(e)=>{
              e.preventDefault()
              console.log(showList,formData.centers,"centers")
              setShowList(!showList)
              }}>Center List</button>
             
           {showList && <div className='centers'>
              {formData.centers && formData.centers.map((option) => (
                <div key={option} style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0' }}>
                  <span>{option}</span>
                  <button className='addNewButton' onClick={(e) => {
                    e.preventDefault()
                    removeCenterFromFrontend(option)
                  }}>-</button>
                </div>
              ))}
            </div>}
          </div>

          <div className="row">
           
            <div className="input-field ">
              
              <input
                 className='custom'
                name="address"
                type="text"
                value={formData.address || ''}
                onChange={handleChange}
              
              />
              <label className="active">Address</label>
            </div>
            <div className="input-field">
              <Select name='trainerTeacher'  onChange={handleTrainer} value ={teachers.filter(teacher=>teacher.id === formData.trainerTeacherId)} options={teachers} getOptionLabel={(option) => option.name} getOptionValue={(option)=>option.id}/>
              <label className="active">Trainer Teacher</label>
            </div>
          </div>

          <div className="row">
      
            <button type="submit" className="btn" >
              {mode === 'View' ? 'Save' : 'Add Teacher'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ModalExample;

